import {LocalDate} from '@js-joda/core';
import {DatepickerValue} from '../datepicker.models';

/** Общие правила завершённого и предварительного выбора диапазона. */
export class DateRangeSelection {
  /** Первое нажатие задаёт опорную дату, поэтому второе может быть раньше первого. */
  public static between(first: LocalDate, second: LocalDate): DatepickerValue {
    return first.isAfter(second) ? {start: second, end: first} : {start: first, end: second};
  }
}
